import UserService from 'Services/user';
import DeviceService from 'Services/device';

export default {
	name: 'DevicePairing',
	props: {
		sectionWrapperClass: {
			value: String
		},
		pinRefreshable: {
			value: Boolean,
			default: true
		}
	},
	created() {
		UserService.getCurrentPIN().then(response => {
			this.pin = response.data.Pin;
			this.isLoading = false;
			this.email = this.$store.state.user.profile.email;
		});
	},
	data() {
		return {
			pin: '',
			isLoading: false,
			isSendingInvitation: false,
			downloadApplicationLink: process.env.GOOGLE_PLAY_STORE_DOWNLOAD_LINK,
			email: ''
		};
	},
	methods: {
		renewPIN() {
			this.isLoading = true;
			UserService.renewPIN().then(response => {
				this.pin = response.data.Pin;
				this.isLoading = false;
			});
		},
		sendInvitation() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.isSendingInvitation = true;
					DeviceService.sendInvitation(this.email)
						.then(response => {
							this.$emit('close');
						})
						.catch(error => {
							this.isSaving = false;
							this.errors.add({
								field: 'apierror',
								msg: error.response.data.Message
							});
						})
						.finally(() => {
							this.isSendingInvitation = false;
						});
				}
			});
		}
	},
};



// WEBPACK FOOTER //
// ./app/components/device-pairing/script.js